var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { T } from 'helpers/i18n';
import { toDate, toMoney } from 'helpers/Format';
import { dateMonthsBefore } from 'helpers/Date';
import { Modal, Table } from 'components';
import { Button, DatePicker } from 'elements';
class Report extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            from: dateMonthsBefore(new Date(), 1),
            to: new Date(),
            fromVisible: false,
            toVisible: false
        };
        this.handleOnSelectItem = (item) => {
            console.log('TicketsReport - handleOnSelectItem - item: ', item);
            const { items } = this.props;
            const ticket = items.filter((value) => value.id === item.id);
            this.props.onSelectItem(ticket[0]);
        };
        this.toggleFromModal = () => this.setState({ fromVisible: !this.state.fromVisible });
        this.toggleToModal = () => this.setState({ toVisible: !this.state.toVisible });
        this.handleFromChange = (_, from) => {
            this.toggleFromModal();
            this.setState({ from });
        };
        this.handleToChange = (_, to) => {
            this.toggleToModal();
            this.setState({ to });
        };
        this.filteredItems = items => {
            const { from, to } = this.state;
            // return items
            return items.filter(item => item.date < to && item.date > from);
        };
    }
    render() {
        const _a = this.props, { header, items, total, format } = _a, props = __rest(_a, ["header", "items", "total", "format"]);
        const { from, to, fromVisible, toVisible } = this.state;
        const filterDate = props.filterDate === undefined ? true : props.filterDate;
        const filteredItems = filterDate ? this.filteredItems(items) : items;
        const fomatedItems = format(filteredItems);
        return (React.createElement("div", null,
            props.filterDate && React.createElement(Header, null,
                T('from'),
                ":",
                ' ',
                React.createElement(Button, { onClick: this.toggleFromModal }, toDate(from)),
                T('to'),
                ": ",
                React.createElement(Button, { onClick: this.toggleToModal }, toDate(to))),
            React.createElement(Table, Object.assign({ onSelectItem: this.handleOnSelectItem }, props, { items: fomatedItems, header: header, search: false })),
            total && (React.createElement(Total, null,
                T('total'),
                " ",
                toMoney(total(filteredItems)))),
            fromVisible && (React.createElement(Modal, { title: T('from') },
                React.createElement(DatePicker, { name: 'from', date: from, onChange: this.handleFromChange }))),
            toVisible && (React.createElement(Modal, { title: T('to') },
                React.createElement(DatePicker, { name: 'to', date: to, onChange: this.handleToChange })))));
    }
}
export default Report;
const Header = cxs('div')({
    paddingLeft: Theme.size.space[1]
});
const Total = cxs('div')({
    padding: Theme.size.space[1],
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    textAlign: 'right'
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/components/Report.tsx
// module id = 231
// module chunks = 0